// Centralized runtime config.
//
// Values are baked in at build time by Create React App. Switch deployment
// mode by overwriting frontend/.env from one of the presets:
//
//   npm run mode:local
//   npm run mode:server-ip
//   npm run mode:server-domain
//
// Then restart `npm start` (dev) or rerun `npm run build` (prod).

const stripSlash = (s) => (s || '').replace(/\/+$/, '');

// Absolute base for REST calls. Empty string => same-origin (relative URLs),
// which is correct for local dev (via CRA proxy or same host) and for the
// single-nginx server-ip mode where /api is proxied alongside /.
export const API_BASE = stripSlash(process.env.REACT_APP_API_URL || '');

// Absolute origin for socket.io. Empty string in env => same-origin.
export const WS_URL =
  process.env.REACT_APP_WS_URL ||
  (typeof window !== 'undefined' ? window.location.origin : '');

// Human-readable label of the active mode. Useful for debug overlays and
// for sanity-checking that the right .env was loaded into the build.
export const MODE = process.env.REACT_APP_MODE || 'unknown';

// Convenience helper so call sites don't sprinkle template literals around.
export const apiUrl = (path) =>
  `${API_BASE}${path.startsWith('/') ? '' : '/'}${path}`;
